import { render, staticRenderFns } from "./SportCenterRouter.vue?vue&type=template&id=4b14f8b8&scoped=true"
import script from "./SportCenterRouter.vue?vue&type=script&lang=js"
export * from "./SportCenterRouter.vue?vue&type=script&lang=js"
import style0 from "./SportCenterRouter.vue?vue&type=style&index=0&id=4b14f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14f8b8",
  null
  
)

export default component.exports